import { render, staticRenderFns } from "./CargoImportDetails.vue?vue&type=template&id=2c533184"
import script from "./CargoImportDetails.vue?vue&type=script&lang=js"
export * from "./CargoImportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports